module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_04-450-60375ecd359dae2e7c0d5de5ce81e041.png";